export default __webpack_public_path__ + "static/splash-3fd276aec5f54ad8c4d8c3f64203b575.svg";